import { Component, Input, Output, EventEmitter, OnInit, AfterViewInit, Inject } from '@angular/core';
import { SessionStorage } from '@bhtp-client-api/base';
import { ModalService } from '@bhtp-client-web/component';
import { ReceiptData } from './../../models/receipt/receipt-data.model';
import { PrintService, TramsService } from './../../services';
import { PolicyFlightOverride } from '@bhtp-client-web/component';
import * as moment from 'moment';
import { Constants } from './../../settings/constants';

@Component({
    selector: 'receipt',
    template: require('./receipt.component.html')
})
export class ReceiptComponent implements OnInit, AfterViewInit {
    @Input() public policyNumber: string;
    @Output() public viewPolicy: EventEmitter<string> = new EventEmitter<string>();
    @Output() public editPolicy: EventEmitter<string> = new EventEmitter<string>();

    public receiptLogoUrl: string;
    private data: ReceiptData;
    private flightReminderPolicy: PolicyFlightOverride;

    constructor(private sessionStorage: SessionStorage, private printService: PrintService,
        private tramsService: TramsService, private modalService: ModalService, @Inject('globalSettingsService') private globalSettingsService: any) { 
            this.receiptLogoUrl = globalSettingsService.baseCdnUrl() + globalSettingsService.authLogoUrl();
        }

    public ngOnInit(): void {
        this.getReceiptData();
        this.checkTrams();
    }

    public ngAfterViewInit(): void {
        // check to see if we have any error messages to show the user.
        // we're mainly interested in refund issues.
        if (this.data.quoteResponse && this.data.quoteResponse.messages && this.data.quoteResponse.messages.length > 0) {
            this.modalService.showApiMessageModal(this.modalService.getApiMessageModalOptions('Notice', this.data.quoteResponse.messages));
        }
    }

    public onViewPolicy(): void {
        this.viewPolicy.emit(this.policyNumber);
    }

    public directToEdit(policyNumber: string): void {
        this.viewPolicy.emit(policyNumber);
    }

    public loadTramsReceipt(): void {
        try {
            let xmlString: string = this.tramsService.generateXml(this.data);
            document.cookie = 'xml=' + encodeURI(xmlString);
            window.location.href = '/tramsreceipt';
        }
        catch (err) {
            this.modalService.showMessageModal('Error', 'There was an error generating the recept page.');
        }
    }

    public print(elementId: string): void {
        this.printService.printFromId(elementId, 'Receipt');
    }

    public showBillingData(): boolean {
        let showBilling: boolean = false;

        if (this.data.transactions && this.data.transactions.length > 0) {
            showBilling = true;
        }

        return showBilling;
    }

    private getReceiptData(): void {
        if (this.policyNumber) {
            let storageName: string = `receipt-${this.policyNumber}`;
            let receiptData: string = this.sessionStorage.getValue(storageName);
            if (receiptData) {
                this.data = JSON.parse(receiptData);
                this.getMomentDates(this.data);
                this.flightReminderPolicy = this.convertReceiptIntoFlightReminderPolicy(this.data);

                // clear the receipt and any purchase data from session
                // to debug the receipt page, comment these out
                this.sessionStorage.removeValue(storageName);
                this.sessionStorage.removeValue('sessionId');
                this.sessionStorage.removeValue('purchaseData');
                this.sessionStorage.removeValue('config');
                this.sessionStorage.removeValue('currentQuote');
            }
        }
    }

    private getMomentDates(rData: ReceiptData): void {
        if (rData) {
            if (rData.primaryTraveler && rData.primaryTraveler.birthDate) {
                rData.primaryTraveler.birthDate = moment(rData.primaryTraveler.birthDate).format(Constants.DATE_DISPLAY_FORMAT);
            }

            if (rData.additionalTravelers && rData.additionalTravelers.length > 0) {
                rData.additionalTravelers.forEach((traveler) => {
                    if (traveler.birthDate) {
                        traveler.birthDate = moment(traveler.birthDate).format(Constants.DATE_DISPLAY_FORMAT);
                    }
                });
            }
        }
    }

    private checkTrams(): void {
        if (this.data) {
            this.data.isCustomSession = this.tramsService.isTramsSession();
        }
    }

    private convertReceiptIntoFlightReminderPolicy(receiptData: ReceiptData): PolicyFlightOverride {
        let converted: PolicyFlightOverride = new PolicyFlightOverride();

        converted.policyNumber = receiptData.policyNumber;
        converted.flightCount = receiptData.flights ? receiptData.flights.length : 0;
        converted.futureFlightsExpected = receiptData.futureFlightsExpected;
        converted.overrideRequiresFlights = receiptData.overrideRequiresFlights;

        if (receiptData && receiptData.purchasedPackage && receiptData.purchasedPackage.configuration) {
            converted.doesPackageHaveConditionalFlights = receiptData.purchasedPackage.configuration.flightRequirementType === 'Conditional';
        }

        return converted;
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/typescript/shared/components/receipt/receipt.component.ts